import React from 'react'
import * as Helpers from '../../../global/Helpers';
import * as Constants from '../../../constants/Constants';

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SpinnersLoadingSIP from '../../SpinnersLoadingSIP/SpinnersLoadingSIP';

toast.configure();
class CustomReactComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.customInitialize();
        this.state = {
            isLoaderVisible: false
        }
    }

    componentDidMount() {
        this.customInitialize();
    }

    componentDidUpdate() {
        this.customInitialize();
    }

    customInitialize = () => {
        this.dir = "ltr";

        this.leftLocalized = "left";
        this.floatRightLocalized = "right";

        this.mrAutoLocalized = "mr-auto";
        this.mlAutoLocalized = "ml-auto";

        this.ml1Localized = "ml-1";
        this.ml2Localized = "ml-2";
        this.ml3Localized = "ml-3";
        this.ml4Localized = "ml-4";
        this.ml5Localized = "ml-5";

        this.mr1Localized = "mr-1";
        this.mr2Localized = "mr-2";
        this.mr3Localized = "mr-3";
        this.mr4Localized = "mr-4";
        this.mr5Localized = "mr-5";

        this.ml3LocalizedPopupHeader = "";
        this.mr3LocalizedPopupHeader = "mr-3"; //in "ar" it is empty

        this.pl1Localized = "pl-1";
        this.pr1Localized = "pr-1";
        this.pr3Localized = "pr-3";

        let language = Helpers.getCurrentLanguage();
        //console.log("language custom react component: ", language)
        if (language === "ar") {
            this.dir = "rtl";

            this.mrAutoLocalized = "ml-auto";
            this.mlAutoLocalized = "mr-auto";

            this.leftLocalized = "right";
            this.floatRightLocalized = "left";

            this.mr1Localized = "ml-1";
            this.mr2Localized = "ml-2";
            this.mr3Localized = "ml-3";
            this.mr4Localized = "ml-4";
            this.mr5Localized = "ml-5";

            this.ml1Localized = "mr-1";
            this.ml2Localized = "mr-2";
            this.ml3Localized = "mr-3";
            this.ml4Localized = "mr-4";
            this.ml5Localized = "mr-5";

            this.ml3LocalizedPopupHeader = "mr-3";
            this.mr3LocalizedPopupHeader = "";

            this.pr1Localized = "pl-1";
            this.pl1Localized = "pr-1";
            this.pr3Localized = "pl-3";

        }
    }

    ErrorFallback = ({ error, resetErrorBoundary }) => {

        return (
            <div role="alert">
                <div>Oh no</div>
                <p>{error.message}</p>
                <button
                    className="btn btn-danger"
                    onClick={() => {
                        // this next line is why the fallbackRender is useful
                        //this.resetComponentState()
                        // though you could accomplish this with a combination
                        // of the FallbackCallback and onReset props as well.
                        Helpers.emptyCache();
                        resetErrorBoundary()
                    }}
                >
                    Try again
                </button>
            </div>
        )
    }

    // successNotify = (message) => {
    //     toast.success(message, {
    //         position: toast.POSITION.BOTTOM_CENTER,
    //         hideProgressBar: true,
    //         autoClose: Constants.successNotifyDuration
    //     });
    // };

    // errorNotify = (message) => {
    //     toast.error(message, {
    //         position: toast.POSITION.BOTTOM_CENTER,
    //         hideProgressBar: true,
    //         autoClose: Constants.errorNotifyDuration
    //     });
    // };

    getLoader = (isLoaderVisible) => {
        return (
            isLoaderVisible
                ? <div className="container-loader" >
                    <div style={localStorage.getItem(Constants.localStorageConstants.company_name) === "SIFS" ? { height: "100%" } : { display: "inline-block", top: "40%", position: "absolute" }}>
                        {localStorage.getItem(Constants.localStorageConstants.company_name) === "SIFS" ? <SpinnersLoadingSIP /> :
                            <Loader
                                type="Bars"
                                color="#00BFFF"
                                height={100}
                                width={100}
                                visible={true}
                            />}
                    </div>
                </div>
                : null
        )
    }

    // getLoaderThreeDots = (isLoaderVisible) => {
    //     return (
    //         isLoaderVisible ?
    //             <ThreeDots
    //                 height="80"
    //                 width="80"
    //                 radius="9"
    //                 color="#000"
    //                 ariaLabel="three-dots-loading"
    //                 wrapperStyle={{}}
    //                 wrapperClassName=""
    //                 visible={true}
    //             /> : null
    //     )
    // }
}

export default CustomReactComponent